import { mapQuery } from "../../utilities/query/mapQuery";
import { useLogbookSettings } from "./useLogbookSettings";

/**
 * Returns the configured trip reasons for the current database.
 */
export function useTripReasons() {
  return mapQuery(
    useLogbookSettings(),
    (settings) => settings.tripReasons ?? []
  );
}
